import * as React from 'react';
import { Avatar } from '@mui/material';

import { getColor } from '../core/colors';

interface IFormAvatar {
  color: string | null | undefined;
  title: string | undefined;
  style?: React.CSSProperties;
  hasDecorator?: boolean;
}

function FormAvatar({ color, title, style, hasDecorator = false }: IFormAvatar) {
  const validColor = (c: string | null | undefined) => {
    const col = getColor(c);
    if (col) return col[500];

    return 'gray';
  };
  return (
    <Avatar
      sx={{
        width: 80,
        px: 1,
        mr: 2,
        backgroundColor: validColor(color),
        backgroundImage: `${hasDecorator ? 'repeating-linear-gradient(to right, transparent 0, transparent 5%, #D4AF37 5%, #D4AF37 10%, transparent 10%, transparent 13%, #D4AF37 13%, #D4AF37 17%, transparent 17%, transparent 83%, #D4AF37 83%, #D4AF37 87%, transparent 87%, transparent 90%, #D4AF37 90%, #D4AF37 95%, transparent 95%, transparent 100%)' : 'none'}`,
      }}
      style={style}
      variant="rounded"
    >
      {title?.match(/[A-Z]/g)?.join('') ?? ''}
    </Avatar>
  );
}

export default FormAvatar;
